import { IPxHeightData } from "./height-data";
import { IWidgetVisibility, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IEmbedWidgetData extends IWidgetVisibility {
    readonly type: "EmbedWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    embedType: "code" | "iframe";
    code: string;
    title: string;
    style: IEmbedWidgetStyle | null;
}

export interface IEmbedWidgetStyle extends IAnimatedWidget {
    heightData?: IPxHeightData | null;
}

export abstract class EmbedWidgetData {

    public static get defaultData(): IEmbedWidgetData {
        return {
            type: "EmbedWidget",
            placeType: "Section",
            embedType: "code",
            code: `<!-- Your Snippet Start -->
<!--Your Snippet End -->`,
            title: "Embed Widget",
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData()
        };
    }

    public static get defaultStyle(): IEmbedWidgetStyle {
        return {
            heightData: {
                height: 128
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

}
